import React from 'react';

export default function SelectPage({ onSelect, karma, talents, onToggleTalent, activeTalents }) {
  const models = [
    { key: "gpt", name: "🤖 激进大模型", desc: "AI优先，全面提效，快速淘汰低端CRUD" },
    { key: "safe", name: "🛡️ 保守私有化", desc: "数据安全第一，求稳，给人类留点活路" },
    { key: "open", name: "🌍 开源社区", desc: "人人可用，百花齐放，卷死所有人" },
    { key: "capital", name: "💰 资本概念", desc: "圈钱圈地，不管落地，PPT造车" }
  ];

  return (
    <div style={styles.containerIntro} className="no-select">
      <div style={{ animation: "fadeIn 0.5s" }}>
        
        {/* ========================================== */}
        {/* 🌟 核心新增：业力点数与天赋商城 */}
        {/* ========================================== */}
        <h2 style={{ textAlign: "center", margin: "0 0 15px 0" }}>
          账户业力: <span style={{ color: '#ffeb3b', textShadow: '0 0 10px rgba(255,235,59,0.5)' }}>{karma}</span> 点
        </h2>
        
        <div style={{ marginBottom: 30, padding: 15, background: 'rgba(0,0,0,0.3)', borderRadius: 10, border: '1px solid #333' }}>
          <p style={{ fontSize: 13, color: "#aaa", marginTop: 0, marginBottom: 15 }}>
            💡 轮回天赋（点击消耗业力点数装备）：
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {talents && talents.map(t => {
              const isActive = activeTalents.includes(t.id);
              return (
                <div 
                  key={t.id} 
                  onClick={() => onToggleTalent(t)}
                  style={{
                    ...styles.talentCard,
                    borderColor: isActive ? '#4caf50' : '#444',
                    background: isActive ? 'rgba(76, 175, 80, 0.15)' : '#222'
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                    <span style={{ fontSize: 15, fontWeight: 'bold', color: isActive ? '#4caf50' : '#eee' }}>
                      {t.name}
                    </span>
                    <span style={{ fontSize: 12, color: isActive ? '#4caf50' : '#ff9800', fontWeight: 'bold' }}>
                      {isActive ? '✅ 已装备' : `💎 消耗: ${t.cost}`}
                    </span>
                  </div>
                  <div style={{ fontSize: 12, color: '#aaa', lineHeight: 1.4 }}>{t.desc}</div>
                </div>
              );
            })}
          </div>
        </div>

        {/* ========================================== */}
        {/* 原有：路线选择区域 */}
        {/* ========================================== */}
        <h2 style={{ textAlign: "center", borderTop: '1px dashed #444', paddingTop: 20 }}>选择你的初始“作恶”路线</h2>
        <p style={{ fontSize: 13, color: "#888", textAlign: "center", marginBottom: 20 }}>不同的底层模型将决定初期行业的受灾方向</p>
        
        {models.map((m) => (
          <div key={m.key} style={styles.card} onClick={() => onSelect(m.key)}>
            <h3 style={{ margin: "0 0 5px 0" }}>{m.name}</h3>
            <span style={{ fontSize: 12, color: "#aaa" }}>{m.desc}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  // 增加了 maxHeight 和 overflowY 让页面在手机上或者内容过多时可以滚动
  containerIntro: { 
    maxWidth: 420, 
    margin: "5vh auto", 
    padding: 20, 
    background: "#121212", 
    color: "#eee", 
    borderRadius: 12,
    maxHeight: '85vh',
    overflowY: 'auto',
    scrollbarWidth: 'none' // 隐藏火狐滚动条
  },
  card: { background: "#1e1e1e", padding: 20, borderRadius: 10, marginBottom: 15, cursor: "pointer", transition: "transform 0.2s, background 0.2s" },
  talentCard: { padding: 15, borderRadius: 8, border: '2px solid', cursor: 'pointer', transition: 'all 0.2s ease' }
};